module.exports = __webpack_public_path__ + "img/tu09.f0e5db53.png";